module.exports = __webpack_public_path__ + "assets/img/eternia-solar-logo-small.9d1e0478.png";